import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CountUp from 'react-countup';

import './Loading.scss';
import { LoadingState } from '../../models/Models';
import { ADAARIARoles } from '../../models/ADA';

const Loading = ({ loadingState, onLoaded, showTextOnly }) => {
  const animationTime = 4;
  const cmsData = useSelector(state => state.data.cms.global);
  const [currentState, setCurrentState] = useState(LoadingState.Waiting);
  const menuOpened = useSelector(state => state.data.menuOpened);

  useEffect(() => {
    setCurrentState(loadingState);
  }, [loadingState]);

  return (
    <div className="loading-content">
      <div
        className={`text-bg ${currentState === LoadingState.Loading ? 'animate' : ''} ${
          showTextOnly ? 'show-text' : ''
        }`}
        style={{ transitionDuration: animationTime + 's' }}
      ></div>
      <div className="text-fg">
        <div className="header" role={ADAARIARoles.Heading} aria-level={1}>{cmsData ? cmsData.Loading.Header : ''}</div>
        <div className="body">{cmsData ? cmsData.Loading.Body : ''}</div>
        {currentState === LoadingState.Loading && !showTextOnly ? (
          <div className="percent-text">
            <CountUp
              start={0}
              end={100}
              duration={animationTime}
              useEasing={false}
              onEnd={onLoaded}
            />
            %
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default Loading;
